import { takeEvery, all, select, put, call } from 'redux-saga/effects';
import { Url } from '@wix/da-url';
import ddt from '@wix/da-ddt';
import { restrictLoggedOut, verifyLoggedOutAccess, VERIFY_ACCESS } from './actionCreators';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { logBiEvent } from '../../biLogger/redux/saga';
import { getPageBiContext } from '../../biLogger/redux/selectors';
import { BiData, BiEvent, RedirectToLoginBiEvent } from '@wix/da-bi/pkg/events';

function* handleRestrictLoggedOut({
  payload: { restrictedActionName, returnTo, returnType },
}: ReturnType<typeof restrictLoggedOut>) {
  if (restrictedActionName) {
    const biContext: ReturnType<typeof getPageBiContext> = yield select(getPageBiContext);
    const event: BiEvent = BiData<RedirectToLoginBiEvent>({
      evid: 240,
      ...biContext,
      referral_info: restrictedActionName,
    });
    yield call(logBiEvent, event);
  }

  const url = Url.joinLink(undefined, returnTo, returnType);
  ddt.log('yumeruby', 'Loggedout redirect', url);
  window.location.assign(url);
}

function* handleVerifyLoggedOutAccess({
  payload: { action, restrictedActionName },
}: ReturnType<ReturnType<typeof verifyLoggedOutAccess>>) {
  const isLoggedIn = yield select(getIsLoggedIn);

  if (isLoggedIn) {
    yield put(action);
    return;
  }

  yield call(handleRestrictLoggedOut, restrictLoggedOut({ restrictedActionName }));
}

export default function* loggedOutRootSaga() {
  yield all([
    takeEvery(restrictLoggedOut, handleRestrictLoggedOut),
    takeEvery(VERIFY_ACCESS, handleVerifyLoggedOutAccess),
  ]);
}
